<script lang="ts">
  import { counter } from "$lib/actions/counter";
  import { observe } from "$lib/actions/observe";

  let { stats = [] as Array<{ value: number; suffix?: string; label: string }> } = $props();
</script>

<div class="container stats-grid fade-up" use:observe style="padding:2rem 0">
  {#each stats as stat}
    <div>
      <div class="stat-value">
        <span data-count={stat.value} use:counter>{stat.value}</span>{stat.suffix}
      </div>
      <div class="stat-label">{stat.label}</div>
    </div>
  {/each}
</div>
